import React from 'react';
import {StyleSheet, View, TouchableWithoutFeedback, Platform, Image} from 'react-native';

import {SVGIcon} from '../../components';
import {getFocusedRouteNameFromRoute, useNavigation, useRoute} from '@react-navigation/native';
import {NavigationKey} from '../../navigations/config';
import { width, height, totalSize } from 'react-native-dimension';
import useStores from '../../stores/useStores';
import {Icon} from 'react-native-elements'; // rne-netzon replaced
import { colorPalette } from '../../../core/config/color.config';
// import AppointmentIcon from '../../../assets/images/Appointment.png';
import ConsultationIcon from '../../../assets/images/consultation_icon.png';

interface HeaderProfileRightProps {
  showMessageIcon?: boolean;
  isMenuLight?: boolean;
  onClick?: () => void;
}

const HeaderProfileRight = (props: HeaderProfileRightProps) => {
  const navigation = useNavigation();
  const {authStore} = useStores();

  const route = useRoute();

  const routeName = getFocusedRouteNameFromRoute(route) ?? route.name;
  const getMenuMarginRightSize = () => {

    if(Platform.OS === 'ios'){
      if(routeName === NavigationKey.PATIENT_SCREEN_LANDING) {
        return -totalSize(0.5);  
      } else if(routeName === NavigationKey.PATIENT_CONSULTATION_REQUEST
        || routeName === NavigationKey.PATIENT_SEARCH_RESULT
      ) {
        return -totalSize(0.5);
      } else  {
        return -totalSize(11.5);
      }
    }else{
      if(routeName === NavigationKey.PATIENT_SCREEN_LANDING) {
        return totalSize(2.5);
      } else if(routeName === NavigationKey.PATIENT_CONSULTATION_REQUEST
        || routeName === NavigationKey.PATIENT_SEARCH_RESULT
      ) {
        return totalSize(2.5);
      } else  {
        return -totalSize(11.5);
      }
    }
  }

  return (
    <View style={[mobileStyles.rightSideContainer,authStore.auth?.user.userRole == 'practitioner' && {marginRight:0, width:width(15)}]}>
      <View style={mobileStyles.iconsContainer}>
        {props.showMessageIcon && (
          <TouchableWithoutFeedback
            onPress={() =>
              navigation.navigate(NavigationKey.PATIENT_CONSULTATION_STACK, {
                screen: NavigationKey.CONSULTATION_LIST,
                params: {
                  screen: NavigationKey.CONSULTATION_TAB_ONGOING,
                },
              })
            }>
            <View style={mobileStyles.iconContainer}>
              <Image 
                source={ConsultationIcon}
                resizeMode='contain'
                style={{
                  width: width(7.5), 
                  height: width(8)
                }}
              />
              {/* <SVGIcon name="email" size={20} /> */}
            </View>
          </TouchableWithoutFeedback>
        )}
        {/* <TouchableWithoutFeedback onPress={props.onClick}> */}
          <View style={mobileStyles.iconContainer}>

            {
              authStore.auth?.user.userRole == 'patient' && (
                <TouchableWithoutFeedback onPress={props.onClick}>
                  <View style={{marginRight: getMenuMarginRightSize()}}>
                    <Icon
                      type="material-community"
                      name="menu"
                      size={Platform.OS === 'ios' ? totalSize(3.5) : totalSize(3.8)}
                      color={colorPalette.primary}
                    />
                  </View>
                  </TouchableWithoutFeedback>
              )
            }

            {
              authStore.auth?.user.userRole == 'practitioner' && (
                 <TouchableWithoutFeedback onPress={props.onClick}>
                  <Icon
                    type="material-community"
                    name="menu"
                    size={totalSize(4)}
                    color={colorPalette.white}
                  />
                  </TouchableWithoutFeedback>
              )
            }

           
          </View>
        {/* </TouchableWithoutFeedback> */}
      </View>
    </View>
  );
};

export default HeaderProfileRight;

const mobileStyles = StyleSheet.create({
  rightSideContainer: {
    marginRight: totalSize(2),
    width: width(16),
  },
  iconsContainer: {
    flexDirection: 'row',
    // paddingHorizontal: 12,
    // marginRight: Platform.OS === 'android' ? totalSize(2) : totalSize(0.5),
    alignContent:'center'
  },
  iconContainer: {
    paddingHorizontal: Platform.OS === 'android' ? totalSize(0.5) : totalSize(0.5),
    // justifyContent:'center',

  },
});
